<template>
  <section class="container">
    <div class="login-wrapper">
      <div id="Dokobit-identity-container" />
      <br><br>
    </div>
    <LoginAgreementModal
      id="agreementModal"
      :isCreateBtnDisabled="isAgreementRequestInProgress"
      :visible="isAgreementVisible"
      @close="closeAgreement"
      v-on="{ agree: acceptAgreement }" />
  </section>
</template>

<script>
import axios from 'axios';
import LoginAgreementModal from '../components/LoginAgreementModal';
import AcceptAgreement from '../mixins/AcceptAgreement.js';

const API_URL = import.meta.env.VITE_API_URL;

export default {
  components: {
    LoginAgreementModal,
  },
  mixins: [AcceptAgreement],
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler: 'loadLoginForm',
    },
  },
  methods: {
    loadLoginForm() {
      axios.get(`${API_URL}/auth/create`)
        .then(({ data }) => {
          if (data.status === 'ok') {
            new DokobitIdentity({ // eslint-disable-line no-undef
              sessionToken: data.session_token,
              locale: this.$i18n.locale,
              primaryColor: '#C40F11',
              callback: (token) => {
                axios.post(`${API_URL}/auth/login`, { session_token: token })
                  .then((response) => {
                    const loginData = response.data;
                    if (loginData.status === 'authorized') {
                      this.login(loginData.token);
                    } else if (loginData.status === 'authenticated') {
                      this.showAgreement(loginData.token);
                    }
                  });
              },
            }).init();
          }
        });
    },
  },
};
</script>
